/**
 * 自动降级订阅器 :: 挂在 Canvas 内（useFrame 上下文）。
 */
import { useAutoDegrade } from '@/systems/useAutoDegrade'

export function AutoDegrade() {
  useAutoDegrade()
  return null
}
